import {ChequeCotizacionListFilter} from "../models/cotizacion-list-filter.model";
import {TransaccionListFilter} from "../models/transaccion-list-filter.model";

export class GetTransaccionListAction {
  static readonly type = '[Transaccion] GetTransaccionListAction';
  constructor() {}
}
export class GetTransaccionAction {
  static readonly type = '[Transaccion] GetTransaccionAction';
  constructor(public payload: {transaccionId}) {}
}
export class CreateTransaccionAction {
  static readonly type = '[Transaccion] CreateTransaccionAction';
  constructor(public payload: {userReceiverId:any, importe:any}) {}
}

export class SearchTransaccionListAction {
  static readonly type = "[Cheque] SearchTransaccionListAction";
  constructor(public payload: { filter: TransaccionListFilter }) {}
}

export class ResetTransaccionListFilter {
  static readonly type = "[Transaccion] ResetTransaccionListFilter";
  constructor() {}
}
